import axios from 'axios';
import { acquireToken } from '../../../services/auth';

// eslint-disable-next-line no-unused-vars
const API_BASE_URL =
  'https://cfxrga9qz6.execute-api.eu-central-1.amazonaws.com/v1';

// eslint-disable-next-line no-unused-vars
const API_BASE_UAT_URL =
  'https://024q7nk1l6.execute-api.eu-central-1.amazonaws.com/v1';

// eslint-disable-next-line no-unused-vars
const API_BASE_PROD_URL =
  'https://7b26k5bjvj.execute-api.eu-central-1.amazonaws.com/v1';

// eslint-disable-next-line no-unused-vars
const API_HEADERS = {
  'Content-Type': 'application/json',
  'x-api-key': 'ekYI4qBTmn1KBoUkJvfTQagPS0iERDOG1tfNHbTL',
};

// eslint-disable-next-line no-unused-vars
const API_UAT_HEADERS = {
  'Content-Type': 'application/json',
  'x-api-key': 'KbnKPFxhyv5znlpObgi9h10nUcI1J7nx1qdf4eN9',
};

// eslint-disable-next-line no-unused-vars
const API_PROD_HEADERS = {
  'Content-Type': 'application/json',
  'x-api-key': 'dyUTQB5ugFMiOE1oOIat5Ww6V0QMAjg9far3XAr7',
};

const REPAIR_SELECT_REQUEST_URL = `${process.env.VUE_APP_RS_API_BASE_URL}/items`;
const REPAIR_SELECT_AGENT_URL = `${process.env.VUE_APP_RS_API_BASE_URL}/agent`;

// Chat modes answered by the Repair Select DIJ agent (/agent), not /items.
const AGENT_MODES = ['dij', 'both'];
// The agent only reads the latest turns; sending fewer keeps the request small.
const AGENT_MAX_INTERACTIONS = 10;

function requestTarget(payload) {
  if (
    payload.requestType === 'chatbot' &&
    AGENT_MODES.includes(payload.agentMode)
  ) {
    return {
      url: REPAIR_SELECT_AGENT_URL,
      body: {
        ...payload,
        interactionData: (payload.interactionData || []).slice(
          -AGENT_MAX_INTERACTIONS
        ),
      },
    };
  }
  return { url: REPAIR_SELECT_REQUEST_URL, body: payload };
}

export default {
  async SEND_REPAIR_SELECT_REQUEST(_, payload) {
    if (!payload) {
      console.warn(
        'sendRepairSelectRequest: No data provided for the request.'
      );
      return;
    }

    try {
      // Renew the token if needed; the cached one may have expired. The DIJ
      // modes forward it to DIJ, so it must be valid for the whole answer.
      const accessToken =
        (await acquireToken()) || sessionStorage.getItem('accessToken');
      const { url, body } = requestTarget(payload);
      const response = await axios.post(url, body, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.VUE_APP_RS_API_BASE_X_API_KEY,
          'x-access-token': accessToken,
        },
      });
      return response.data;
    } catch (error) {
      console.error(
        'sendRepairSelectRequest: Request failed:',
        error.response?.data || error.message
      );
      throw new Error('Failed to send repair select request');
    }
  },
};
